exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "html{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;padding:0 32px;padding:0 2rem;height:100%;font-family:sans-serif;text-align:center;color:#888}body{margin:0}h1{font-weight:400;color:#555}pre{white-space:pre-wrap;text-align:left}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"minimize":true,"discardComments":{"removeAll":true},"localIdentName":"[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./node_modules/sass-loader/lib/loader.js!./src/routes/error/ErrorPage.scss
// module id = 671
// module chunks = 2